import ordersApi from "services/ordersApi";
import { DealerDriversInsightResponse } from "types/dealerDriversInsight";

type GetDealerDriversInsightParams = {
  dealerId: string;
  driverIds: string[];
};

function serializeDriverInsightParams(params: Record<string, unknown>): string {
  const searchParams = new URLSearchParams();
  const dealerId = String(params.dealerId ?? "");
  if (dealerId) {
    searchParams.append("dealerId", dealerId);
  }
  const { driverIds } = params;
  if (Array.isArray(driverIds)) {
    driverIds.forEach((driverId) => {
      const normalizedId = String(driverId ?? "").trim();
      if (normalizedId) {
        searchParams.append("driverIds", normalizedId);
      }
    });
  }
  return searchParams.toString();
}

export function mapDealerDriversInsightToActiveOrders(
  response: DealerDriversInsightResponse,
): Map<string, number> {
  const activeOrdersById = new Map<string, number>();
  (response.data ?? []).forEach((item) => {
    const driverId = item.id?.trim();
    if (!driverId) {
      return;
    }
    activeOrdersById.set(driverId, item.totalActiveOrders ?? 0);
  });
  return activeOrdersById;
}

export async function getDealerDriversInsight({
  dealerId,
  driverIds,
}: GetDealerDriversInsightParams): Promise<Map<string, number>> {
  const { data } = await ordersApi.get<DealerDriversInsightResponse>(
    `/v1/dealers/${dealerId}/drivers/insight`,
    {
      params: {
        dealerId,
        driverIds,
      },
      paramsSerializer: serializeDriverInsightParams,
    },
  );
  return mapDealerDriversInsightToActiveOrders(data);
}
